import { render, staticRenderFns } from "./RemoteUpgradeFormRight.vue?vue&type=template&id=2476e1dd&"
import script from "./RemoteUpgradeFormRight.vue?vue&type=script&lang=js&"
export * from "./RemoteUpgradeFormRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports